import { CheckboxGroup } from '@chakra-ui/react';
import AddAnother from '../../Checkboxes/AddAnother';
import CheckBoxes from './CheckBoxes';

const SelectBox=({ props, qObj, val, style })=>{
  return (
    <CheckboxGroup
      name={`jobSeekerData[${props.index}].${props.qid}`}
      label={qObj.question}
      id={qObj.qid}
      value={val}
    >
      <CheckBoxes props={props} qObj={qObj} style={style} />
      <AddAnother props={props} qObj={qObj} style={style} />
    </CheckboxGroup>
  )
}
export default SelectBox;